'use strict';

var schema_1 = require("../schema");

module.exports = new schema_1.Schema({
  include: [require('./failsafe')],
  implicit: [require('../type/null'), require('../type/bool'), require('../type/int'), require('../type/float')]
});